export const initialPrograms = [
  {
    id: 1, title: "Voice Over Mastery", duration: "6 Weeks", skillLevel: "Beginner",
    courseType: "Online", description: "Master professional voice over techniques, mic presence, tone control, and studio etiquette. Build a demo reel ready for real projects."
  },
  {
    id: 2, title: "Sound Design Fundamentals", duration: "8 Weeks", skillLevel: "Intermediate",
    courseType: "Hybrid", description: "Explore the craft of sound design from foley to ambient soundscapes. Learn industry-standard tools and create immersive audio experiences."
  },
  {
    id: 3, title: "Podcast Production Pro", duration: "4 Weeks", skillLevel: "Beginner",
    courseType: "Online", description: "From concept to publishing — learn scripting, recording, editing, and distribution strategies for compelling, accessible podcasts."
  },
  {
    id: 4, title: "Script Writing for Audio", duration: "5 Weeks", skillLevel: "Intermediate",
    courseType: "Online", description: "Write stories, scripts, and narratives that translate powerfully into audio. Study structure, dialogue, and inclusive storytelling practices."
  },
  {
    id: 5, title: "Audio Story Creation", duration: "10 Weeks", skillLevel: "Advanced",
    courseType: "In-Person", description: "A comprehensive course blending narrative design, production, and performance to craft full immersive audio stories from scratch."
  },
  {
    id: 6, title: "Inclusive Media Training", duration: "3 Weeks", skillLevel: "Beginner",
    courseType: "Online", description: "Equip yourself with the skills to create media that is accessible, representative, and resonant across diverse audiences and abilities."
  },
];
